import * as React from 'react'
import { SVGProps } from 'react'
import PropTypes from 'prop-types'
interface SVGRProps {
    title?: string;
    titleId?: string;
}
function SvgLockFill({
    title,
    titleId,
    ...props
}: SVGProps<SVGSVGElement> & SVGRProps) {
    return (
        <svg
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-labelledby={titleId}
            {...props}
        >
            {title ? <title id={titleId}>{title}</title> : null}
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M36.298 19.362h-1.213v-4.447C35.085 8.887 30.198 4 24.17 4 18.14 4 13.255 8.887 13.255 14.915v4.447h-1.213a3.234 3.234 0 0 0-3.234 3.234v16.98a3.234 3.234 0 0 0 3.234 3.234h24.256a3.234 3.234 0 0 0 3.234-3.235V22.596a3.234 3.234 0 0 0-3.234-3.234Zm-19.001-4.447a6.873 6.873 0 0 1 13.745 0v3.639a.809.809 0 0 1-.809.808H18.105a.809.809 0 0 1-.808-.808v-3.639Zm7.219 20.502a4.62 4.62 0 1 0 0-9.24 4.62 4.62 0 0 0 0 9.24Z"
                fill="#297A71"
            />
        </svg>
    )
}
SvgLockFill.propTypes = {
    title: PropTypes.string,
    fill: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string,
    stroke: PropTypes.string,
    color: PropTypes.string,
}
export default SvgLockFill
